import { Download, X } from '@phosphor-icons/react';
import React from 'react';

const Lightbox = ({
    lightboxImage,
    handleOverlayClick,
    closeLightbox,
}: {
    lightboxImage: string;
    handleOverlayClick: any;
    closeLightbox: () => void;
}) => (
    <div id="lightbox-overlay" className="fixed inset-0 bg-black bg-opacity-70 p-4 z-[100]" onClick={closeLightbox}>
        <div className="relative h-full flex items-center justify-center">
            <img
                src={lightboxImage}
                alt="Selected"
                className="bg-chatMessage-image-background max-w-full max-h-full m-[30px]"
                onClick={closeLightbox}
            />
        </div>
        <button
            onClick={async () => {
                const response = await fetch(lightboxImage);
                const blob = await response.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = lightboxImage.split('/').pop() ?? 'Image.png';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }}
            className="absolute top-0 right-[50px] m-[30px] text-white"
        >
            <Download size={30} />
        </button>
        <button onClick={closeLightbox} className="absolute top-0 right-0 m-[30px] text-white">
            <X size={30} />
        </button>
    </div>
);

export default Lightbox;
